<template>
  <div class="" v-show.async="show">
    <el-table v-if="!isMobile()" :data="logs" style="width: 100%" key="logs">
      <el-table-column prop="title" label="类型"></el-table-column>
      <el-table-column label="内容">
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
          <quotation-link
            v-if="scope.row.type == 1 && scope.row.params"
            :quotation="scope.row.params"
          ></quotation-link>
          <purchase-link
            v-else-if="scope.row.type == 9 && scope.row.params"
            :number="scope.row.params.number"
            :id="scope.row.params.id"
          ></purchase-link>
          <shipping-link
            v-else-if="scope.row.type == 11 && scope.row.params"
            :number="scope.row.params.number"
            :id="scope.row.params.id"
          ></shipping-link>
          <div v-else-if="scope.row.type == 14">
            <div v-if="scope.row.params.name">{{ scope.row.params.name }}</div>
          </div>
          <div
            v-else-if="
              scope.row.type == 10 ||
              scope.row.type == 16 ||
              scope.row.type == 21
            "
            v-html="logAddAmount(scope.row.params)"
          ></div>
          <div v-else v-html="logParams(scope.row.params)"></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user.name"
        label="操作人"
        width="140"
      ></el-table-column>
      <el-table-column label="操作时间" width="140">
        <template slot-scope="scope">
          <span>
            {{ formatTime(scope.row.created_at, 'YYYY-M-D HH:mm') }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="item in logs" class="font-12">
        <div class="flex-row-between">
          <span>{{ item.title }}</span>
          <span>
            {{ formatTime(item.created_at, 'YYYY-MM-DD HH:mm') }}
          </span>
        </div>
        <div>
          <span>{{ item.content }}</span>
          <quotation-link
            v-if="item.type == 1 && item.params"
            :quotation="item.params"
          ></quotation-link>
          <purchase-link
            v-else-if="item.type == 9 && item.params"
            :number="item.params.number"
            :id="item.params.id"
          ></purchase-link>
          <shipping-link
            v-else-if="item.type == 11 && item.params"
            :number="item.params.number"
            :id="item.params.id"
          ></shipping-link>
          <div v-else-if="item.type == 14">
            <div v-if="item.params.name">{{ item.params.name }}</div>
          </div>
          <div
            v-else-if="item.type == 10 || item.type == 16 || item.type == 21"
            v-html="logAddAmount(item.params)"
          ></div>
          <div v-else v-html="logParams(item.params)"></div>
        </div>
      </li>
    </ul>
    <div class="mt-20" v-if="logTotal > logRequest.size">
      <el-pagination
        small
        :page-size="logRequest.size"
        :current-page.sync="logRequest.page"
        layout="total, prev, pager, next"
        :total="logTotal"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { customerOrderLogList } from '../../service/getData'
import { formatTime } from '@/util/index'
import { clone } from '@/util'
import { CustomerOrderLogMap } from '@/config/global'
import math from '../../util/math'
import { isMobile } from '../../util'

export default {
  props: {
    customerOrderID: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatTime,
      isMobile,
      logs: [],
      logRequest: {
        page: 1,
        size: 10,
      },
      logTotal: 0,
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.requestCustomerOrderLogList()
      }
    },
    'logRequest.page': function () {
      this.requestCustomerOrderLogList()
    },
  },
  created() {
    if (this.show) {
      this.requestCustomerOrderLogList()
    }
  },
  methods: {
    async requestCustomerOrderLogList() {
      let data = {
        order_id: this.customerOrderID,
        sort: 0,
        page: this.logRequest.page - 1,
        size: this.logRequest.size,
      }
      let res = await customerOrderLogList(data)
      this.logTotal = res.data.total
      this.logs = res.data.list.map((log) => {
        log.title = CustomerOrderLogMap[log.type]
        if (log.type == 8 && log.params) {
          let amount = log.params['amount']
          let date = log.params['date']
          let content = ''
          if (amount) {
            content = '回款金额：￥' + math.show(amount)
          }
          if (date) {
            content += '，到账时间：' + formatTime(date)
          }
          log.content = content
        }
        return log
      })
    },
    logAddAmount(params) {
      let content = ''
      if (params.amount) {
        content += '<div>金额：￥' + math.show(params.amount) + '</div>'
      }
      if (params.date) {
        content += '<div>日期：' + formatTime(params.date) + '</div>'
      }
      return content
    },
    logParams(params) {
      let content = ''
      for (const key in params) {
        let value = params[key]
        let isDate = key.indexOf('时间') != -1
        if (Object.prototype.toString.call(value) == '[object Array]') {
          content += '<div>' + key + '：' + value.join('->') + '</div>'
        } else {
          if (isDate) {
            value = formatTime(value)
          }
          content += '<div>' + key + '：' + value + '</div>'
        }
      }
      return content
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
div.cell p {
  margin: 0;
}
</style>